import { useGetSocialHubNewsQueryQuery } from './graphql/get-social-hub-news-query.v5.generated';

export type TNews = ReturnType<typeof useGetSocialHubNews>['news'][number];

export const useGetSocialHubNews = (centralizedOrganizationId: number) => {
  const { data, loading, error, refetch } = useGetSocialHubNewsQueryQuery({
    variables: {
      input: {
        centralized_organization_id: centralizedOrganizationId,
      },
    },
    notifyOnNetworkStatusChange: true,
    context: { clientName: 'v5' },
  });

  const newsNode =
    data?.social_hub?.social_hub_get_my_news?.__typename ===
    'UserProfileSocialHubNewsInfoNodeCustomConnection'
      ? data.social_hub.social_hub_get_my_news.edges
      : [];

  const news = newsNode.map(({ node }) => ({
    id: node.id,
    title: node.title,
    published_date: node.published_date,
    uploaded_format: node.uploaded_format,
    status: node.status,
    file:
      node.file_info?.file && node.file_info.file.absolute_url
        ? {
            id: node.file_info?.file.id,
            name: node.file_info?.file.name,
            url: node.file_info.file.absolute_url,
            format: node.uploaded_format,
          }
        : null,
    front_page_image_info: node.front_page_image_info,
  }));

  return {
    news,
    loading,
    error,
    refetch,
  };
};
